module.exports = "/images/wm-team-anders.fd6cae581b90bf34d0c48f9a598f7df3.png";